import axios from "axios";

const api = axios.create({
    withCredentials: true,
});

// Inject CSRF manually
api.interceptors.request.use((config) => {
    const token = document.cookie.match(/XSRF-TOKEN-SHOPPING=([^;]+)/)?.[1];

    const method = config.method?.toLowerCase();

    if (token && ["post", "put", "delete", "patch", "get"].includes(method)) {
        config.headers["X-XSRF-TOKEN"] = token;
    }

    return config;
});


export default api;
